import React, { FC, PropsWithChildren } from 'react';
import { styled } from '../../../theme';
import type { GDSCustomizableComponent } from '../../../types';
import { GenesisCoreInspector } from '../../../test-utils/genesis-core-inspector';

const DISPLAY_NAME = 'InputHint';

const HintBase = styled('span', {
  display: 'block',
  margin: 0,
  typography: '$caption',
  color: '$onSurfaceTextSubdued',
});

export interface GDSInputHint extends GDSCustomizableComponent {
  id?: string;
}

export const InputHint: FC<PropsWithChildren<GDSInputHint>> = ({
  children,
  className,
  css,
  id,
  'data-testid': testId = `GDS-${DISPLAY_NAME}`,
  ...props
}) => (
  <GenesisCoreInspector displayName={DISPLAY_NAME}>
    <HintBase
      className={['GDS-input-hint', className].join(' ')}
      id={id}
      css={css}
      data-testid={testId}
      {...props}
    >
      {children}
    </HintBase>
  </GenesisCoreInspector>
);

InputHint.displayName = DISPLAY_NAME;
